// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/count.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum gitpod.v1.CountResponseRelation
 */
export enum CountResponseRelation {
  /**
   * @generated from enum value: COUNT_RESPONSE_RELATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The count is equal to the number of matching records.
   *
   * @generated from enum value: COUNT_RESPONSE_RELATION_EQ = 1;
   */
  EQ = 1,

  /**
   * The actual number of matching records is greater than or equal to the value.
   *
   * @generated from enum value: COUNT_RESPONSE_RELATION_GTE = 2;
   */
  GTE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CountResponseRelation)
proto3.util.setEnumType(CountResponseRelation, "gitpod.v1.CountResponseRelation", [
  { no: 0, name: "COUNT_RESPONSE_RELATION_UNSPECIFIED" },
  { no: 1, name: "COUNT_RESPONSE_RELATION_EQ" },
  { no: 2, name: "COUNT_RESPONSE_RELATION_GTE" },
]);

/**
 * CountRequest controls whether the response should include a bounded
 * count of matching records.
 *
 * @generated from message gitpod.v1.CountRequest
 */
export class CountRequest extends Message<CountRequest> {
  /**
   * When true, the first page of results will include a CountResponse with
   * the bounded total. Subsequent pages (requests with a pagination token)
   * will not contain the count.
   *
   * @generated from field: bool include = 1;
   */
  include = false;

  constructor(data?: PartialMessage<CountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "include", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountRequest {
    return new CountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountRequest {
    return new CountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CountRequest {
    return new CountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CountRequest | PlainMessage<CountRequest> | undefined, b: CountRequest | PlainMessage<CountRequest> | undefined): boolean {
    return proto3.util.equals(CountRequest, a, b);
  }
}

/**
 * CountResponse represents a bounded count of matching records.
 * When the actual count exceeds the counting limit, value is capped and
 * relation is set to GREATER_THAN_OR_EQUAL.
 *
 * @generated from message gitpod.v1.CountResponse
 */
export class CountResponse extends Message<CountResponse> {
  /**
   * The count of matching records, capped at the server's counting limit.
   *
   * @generated from field: int32 value = 1;
   */
  value = 0;

  /**
   * Indicates whether value is the exact total or a lower bound.
   *
   * @generated from field: gitpod.v1.CountResponseRelation relation = 2;
   */
  relation = CountResponseRelation.UNSPECIFIED;

  constructor(data?: PartialMessage<CountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "relation", kind: "enum", T: proto3.getEnumType(CountResponseRelation) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountResponse {
    return new CountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountResponse {
    return new CountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CountResponse {
    return new CountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CountResponse | PlainMessage<CountResponse> | undefined, b: CountResponse | PlainMessage<CountResponse> | undefined): boolean {
    return proto3.util.equals(CountResponse, a, b);
  }
}

